'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdl';
var iconName = 'circle-user';
var width = 512;
var height = 512;
var aliases = [62142,"user-circle"];
var unicode = 'f2bd';
var svgPathData = ['M32 256c0 67.5 29.8 128 77 169l35-105 224 0 35 105c47.2-41.1 77-101.6 77-169 0-123.7-100.3-224-224-224S32 132.3 32 256zm304-64a80 80 0 1 1 -160 0 80 80 0 1 1 160 0z', 'M480 256C480 132.3 379.7 32 256 32S32 132.3 32 256c0 67.5 29.8 128 77 169l35-105 224 0 35 105c47.2-41.1 77-101.6 77-169zM344.9 352l-177.9 0-31.1 93.2c34.7 22 75.9 34.8 120 34.8s85.3-12.8 120-34.8L344.9 352zM0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zm208-64a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 80a80 80 0 1 1 0-160 80 80 0 1 1 0 160z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCircleUser = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;